import React from 'react';

const Footer = () => {
    return (
        <div className=' mt-4 lg:mt-16 pb-4 lg:mr-96'>
           <h1 className='text-base lg:text-xl text-white text-center'>&copy; Designed by    
            <span className=' lg:text-xl ml-2'><a className='text-yellow-500' href="#homepage">Mohammad Borhan Uddin</a> </span>
           </h1> 
        </div>
    );
};

export default Footer;